import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Wagholitomumbaicab() {



const cardData = {
  keyword: " Wagholi to Mumbai Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Wagholi to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Wagholi to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Wagholi to Mumbai cab travel.",

topPlaces: [
  {
    title: "Gateway of India",
    description: "The Gateway of India is one of Mumbai’s most iconic landmarks along the Arabian Sea in South Mumbai. Travelers using a Wagholi to Mumbai cab can conveniently reach this historic monument for sightseeing, photography, and ferry rides to Elephanta Island."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive is a scenic coastal boulevard famous for its sunset views and city lights. A cab from Wagholi to Mumbai allows travelers to enjoy a relaxing drive or evening stroll along this picturesque promenade."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is a popular seaside destination in Mumbai, known for its sandy shores, lively atmosphere, and street food. Travelers arriving from Wagholi by cab can enjoy a comfortable trip directly to this vibrant beach."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple, dedicated to Lord Ganesha, is a revered spiritual landmark in Prabhadevi. Visitors traveling from Wagholi by cab often include this temple in their Mumbai itinerary for blessings and cultural exploration."
  },
  {
    title: "Bandra Worli Sea Link",
    description: "The Bandra Worli Sea Link is an impressive bridge connecting Bandra and Worli with panoramic views of the sea and city skyline. Travelers using a cab from Wagholi can enjoy a smooth and scenic ride across this landmark."
  },
  {
    title: "Haji Ali Dargah",
    description: "Haji Ali Dargah is a well-known mosque and tomb located on a small island off Mumbai’s coast. A cab ride from Wagholi allows travelers to conveniently visit this serene spiritual site and enjoy the seaside ambience."
  },
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves are ancient rock-cut temples on Elephanta Island, famous for intricate carvings and historical significance. Travelers can take a cab from Wagholi to the Gateway of India and then a ferry to explore this UNESCO World Heritage site."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is a large urban forest reserve offering trekking trails, wildlife, and the historic Kanheri Caves. A cab from Wagholi provides easy access to this green retreat for outdoor activities and relaxation."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is a vibrant shopping street in South Mumbai filled with markets, boutiques, and cafes. Travelers arriving from Wagholi by cab can explore this lively area for shopping, dining, and local culture."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens, also called Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Travelers from Wagholi can reach this serene spot easily by cab for relaxation and photography."
  }
],



services: [
{
name: "Wagholi to Mumbai Cab Price",
description: "Wagholi to Mumbai cab price service provides transparent taxi fare details for travelers planning intercity trips between Pune and Mumbai. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway journeys. Professional drivers provide punctual pickup from homes, offices, and residential societies across Wagholi."
},
{
name: "Wagholi to Mumbai Cab",
description: "Wagholi to Mumbai cab service offers reliable transportation between Pune’s Wagholi area and Mumbai city. Comfortable vehicles and experienced drivers ensure safe travel via the Mumbai–Pune Expressway. Ideal for airport transfers, corporate travel, and family trips."
},
{
name: "Wagholi to Mumbai Airport Cab Service",
description: "Wagholi to Mumbai Airport cab service provides dependable airport transportation between Wagholi in Pune and Mumbai Airport terminals. Vehicles offer comfortable seating and luggage space suitable for long-distance airport travel."
},
{
name: "Mumbai to Wagholi Cab Service",
description: "Mumbai to Wagholi cab service provides reliable return transportation for passengers traveling from Mumbai city to Pune’s Wagholi area. Comfortable vehicles and professional drivers ensure safe highway travel."
},
{
name: "Kharadi to Mumbai Airport Cab Service",
description: "Kharadi to Mumbai Airport cab service offers convenient airport transfers between Pune’s IT hub Kharadi and Chhatrapati Shivaji Maharaj International Airport. Comfortable vehicles ensure safe and timely travel."
},
{
name: "Kharadi to Mumbai Airport Cab Service Rates",
description: "Kharadi to Mumbai Airport cab service rates provide clear pricing options for airport travel between Pune and Mumbai. Travelers can choose from sedan, Ertiga, and Innova vehicles depending on group size and comfort needs."
},
{
name: "Lohegaon to Mumbai Airport Cab",
description: "Lohegaon to Mumbai Airport cab service offers reliable airport transfers between Pune’s Lohegaon area and Mumbai Airport terminals. Professional drivers ensure punctual pickups and safe expressway travel."
},
{
name: "Perne Phata to Mumbai Airport Cab",
description: "Perne Phata to Mumbai Airport cab service provides dependable long-distance transportation between Perne Phata and Mumbai Airport. Comfortable vehicles ensure smooth travel along the Pune–Mumbai highway."
},
{
name: "Kesnand to Mumbai Cab Service",
description: "Kesnand to Mumbai cab service offers reliable transportation between Kesnand village near Wagholi and Mumbai city. Comfortable vehicles ensure safe expressway travel for families and corporate travelers."
},
{
name: "Uruli Kanchan to Mumbai Cabs Service",
description: "Uruli Kanchan to Mumbai cab service provides dependable transportation between Pune’s Uruli Kanchan area and Mumbai city. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Mundwa to Mumbai Cabs Service",
description: "Mundwa to Mumbai cab service offers reliable intercity transportation between Pune’s Mundwa area and Mumbai city. Professional drivers and comfortable vehicles ensure smooth journeys."
},
{
name: "Manjari to Mumbai Cabs Service",
description: "Manjari to Mumbai cab service provides dependable transportation between Pune’s Manjari area and Mumbai city. Comfortable vehicles ensure safe and smooth expressway travel."
},
{
name: "Pune Nagar Road to Mumbai Cabs Service",
description: "Pune Nagar Road to Mumbai cab service offers convenient transportation between Pune city and Mumbai. Vehicles are suitable for airport transfers, business trips, and family travel."
},
{
name: "Cab Service in Wagholi",
description: "Cab service in Wagholi provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel experiences."
},
{
name: "Innova Crysta on Rent in Wagholi",
description: "Innova Crysta on rent in Wagholi offers premium SUV transportation for families and corporate travelers. Spacious seating and smooth highway performance ensure comfortable journeys."
},
{
name: "Ertiga on Rent in Wagholi",
description: "Ertiga on rent in Wagholi provides comfortable 7-seater SUV transportation suitable for family trips and airport transfers. The vehicle ensures smooth and economical highway travel."
},
{
name: "Sedan Cabs on Rent in Wagholi",
description: "Sedan cabs on rent in Wagholi provide economical transportation using vehicles like Swift Dzire and Etios. Ideal for airport transfers, city travel, and outstation journeys."
},
{
name: "Cab Service in Wagholi Pune",
description: "Cab service in Wagholi Pune offers dependable transportation for daily commuting, airport transfers, and long-distance journeys. Comfortable vehicles ensure safe and convenient travel."
},
{
name: "Wagholi to Mumbai Cabs",
description: "Wagholi to Mumbai cabs provide reliable intercity travel between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure smooth highway journeys."
},
{
name: "Wagholi to Mumbai Taxi",
description: "Wagholi to Mumbai taxi service offers convenient transportation between Pune’s Wagholi area and Mumbai city. Vehicles are comfortable and suitable for expressway travel."
},
{
name: "Wagholi to Mumbai Cab Service",
description: "Wagholi to Mumbai cab service provides dependable transportation between Pune and Mumbai. Professional drivers ensure safe highway travel and timely pickup services."
},
{
name: "Wagholi to Mumbai Taxi Service",
description: "Wagholi to Mumbai taxi service offers reliable intercity transportation with comfortable vehicles suitable for business travel and family trips."
},
{
name: "Wagholi to Mumbai Cab Booking",
description: "Wagholi to Mumbai cab booking service allows passengers to easily reserve taxis for intercity travel. Flexible booking options ensure convenient travel planning."
}
],

tableData: [
["Wagholi to Mumbai Cab Price","Wagholi to Mumbai Cab"],
["Wagholi to Mumbai Airport Cab Service","Mumbai to Wagholi Cab Service"],
["Kharadi to Mumbai Airport Cab Service","Kharadi to Mumbai Airport Cab Service Rates"],
["Lohegaon to Mumbai Airport Cab","Perne Phata to Mumbai Airport Cab"],
["Kesnand to Mumbai Cab Service","Uruli Kanchan to Mumbai Cabs Service"],
["Mundwa to Mumbai Cabs Service","Manjari to Mumbai Cabs Service"],
["Pune Nagar Road to Mumbai Cabs Service","Cab Service in Wagholi"],
["Innova Crysta on Rent in Wagholi","Ertiga on Rent in Wagholi"],
["Sedan Cabs on Rent in Wagholi","Cab Service in Wagholi Pune"],
["Wagholi to Mumbai Cabs","Wagholi to Mumbai Taxi"],
["Wagholi to Mumbai Cab Service","Wagholi to Mumbai Taxi Service"],
["Wagholi to Mumbai Cab Booking","Wagholi to Mumbai Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Wagholi to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic patterns ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Wagholi to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Wagholi to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Wagholi to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Wagholi",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and residential societies across Wagholi and nearby areas like Kharadi, Lohegaon, Viman Nagar, and Chandan Nagar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Wagholi to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Wagholi to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Wagholi to Mumbai with professional drivers and comfortable vehicles." },
  { question: "How far is Wagholi from Mumbai?", answer: "The road distance from Wagholi to Mumbai is around 150 km and the journey usually takes about 3 to 4 hours depending on traffic conditions." },
  { question: "Is Wagholi to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Wagholi to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Wagholi to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Wagholi and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Wagholi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Wagholi to Mumbai cab services online or through phone booking." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A smooth and comfortable journey from Wakad to Mumbai. The cab was punctual, clean, and the ride felt relaxed throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Wakad to Mumbai cab service was very reliable. The vehicle was well-maintained, the drive was steady, and the entire travel experience felt safe and hassle-free.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wagholi to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Wagholi to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Ertiga, and Sedan cabs for airport transfers, Mumbai Airport, Kharadi, Lohegaon, Perne Phata, Kesnand, Uruli Kanchan, Mundwa, Manjari, Pune Nagar Road, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Wagholi to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      <Helmet>
  <title>Wagholi to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Wagholi to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Innova, Ertiga & Sedan for Mumbai Airport, Kharadi, Lohegaon, Perne Phata, Kesnand, Uruli Kanchan & Mundwa." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Wagholitomumbaicab;